import { createBridgeComponent } from 'mfe-react-bridge';

import App from './App';

export default createBridgeComponent({
  rootComponent: App,
});

export const BRIDGE = true;
